import React, { useLayoutEffect } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import ServicioCryptoAgilidadSection from '../sections/ServicioCryptoAgilidad'
import Seo from '../components/Seo'
import { sizes } from '../utils/breakpoints'

const ServicioCryptoAgilidad = () => {
  const { t } = useTranslation()

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container>
      <Seo
        title={t('seo.cryptoAgilidad.title')}
        description={t('seo.cryptoAgilidad.description')}
        path="/servicios/crypto-agilidad-cbom"
        serviceName={t('seo.cryptoAgilidad.title')}
      />
      <ServicioCryptoAgilidadSection />
    </Container>
  )
}

export default ServicioCryptoAgilidad

const Container = styled.div`
  padding-top: 110px;

  @media (max-width: ${sizes.mobile}px) {
    padding-top: 70px;
  }
`
